





























































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import Input from "@/shared/components/ui/Input.vue";
import LinkedAccountVerificationUmb from "./LinkedAccountVerificationUmb.vue";
import NewLinkedBankAccountForm from "./NewLinkedBankAccountForm.vue";
import {
  LinkedAccountApi,
  AchVerifier
} from "@/shared/types";
import { Validator } from "vee-validate";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";


@Component({
  components: {
    Button,
    Input,
    LinkedAccountVerificationUmb,
    NewLinkedBankAccountForm,
  }
})
export default class LinkedAccountsListElement extends Vue {
  $validator: Validator;

  bankAccountNameEdit = null;
  isEditing = false;
  isEditingVerification = false;

  @Prop()
  linkedAccount: LinkedAccountApi;

  @Prop()
  disabled: boolean;

  bankAccountStore = useBankAccountStore();
  custodianSettingsStore = useCustodianSettingsStore();

  get canEditBankDetails () {
    return this.bankAccountStore.achVerifier === AchVerifier.Umb;
  }

  get portalFunctionalityDisabled (): boolean {
    return this.custodianSettingsStore.portalFunctionalityDisabled;
  }


  get isEditingButtonText () {
    return this.isEditing ? "Cancel" : "Edit";
  }

  get isVerifyingButtonText () {
    return this.isEditingVerification ? "Cancel" : "Verify";
  }

  get showDeleteWarning () {
    return this.isEditing && this.linkedAccount.hasPersonalContributionSchedules;
  }

  get isUnverified () {
    return this.linkedAccount && this.linkedAccount.verificationStatus.toLowerCase() !== "verified";
  }

  get bankAccountName () {
    return (this.bankAccountNameEdit === null)
        ? this.linkedAccount.bankAccountName
        : this.bankAccountNameEdit;
  }

  set bankAccountName (name) {
    this.bankAccountNameEdit = name;
  }

  toggleIsEditing () {
    this.isEditing = !this.isEditing;
    this.$emit("editButtonClicked", this.isEditing);

    if (!this.isEditing) {
      this.bankAccountNameEdit = null;
    }
  }

  toggleIsEditingVerification () {
    this.isEditingVerification = !this.isEditingVerification;
    this.$emit("editButtonClicked", this.isEditingVerification);
  }

  updateThis () {
    if (this.portalFunctionalityDisabled) {
      return;
    }

    if (this.bankAccountNameEdit === null) {
      return;
    }

    this.bankAccountStore.setAccountName({
      name: this.bankAccountNameEdit,
      linkedBankAccountId: this.linkedAccount.linkedBankAccountId
    });
    this.bankAccountStore.putLinkedAccount(this.linkedAccount);
  }

  deleteThis () {
    if (this.portalFunctionalityDisabled) {
      return;
    }

    if (!this.linkedAccount) {
      return;
    }

    this.bankAccountStore.deleteLinkedAccount(this.linkedAccount);
  }

}
